<template>
    <div class="audiences-type-1">{{allAudiences.join(', ')}}</div>
</template>

<script>
export default {
    name: "AudiencesMini",
    props: {
        audiences: {
            type: String,
            default: ''
        }
    },
    computed: {
        allAudiences() {
            return this.audiences ? this.audiences.split('|') : [];
        }
    }
}
</script>